import Vuex from 'vuex'
import Vue from 'vue'
Vue.use(Vuex)
export default new Vuex.Store({
  state: {
    language:'zh',
  },
  mutations: {
    SET_LANGUAGE(state, language) {
      state.language = language;
    }
  },
  actions: {
    set_language({ commit }, language) {
    	commit('SET_LANGUAGE', language)
  	}
  },
  modules: {
    
  }
  
})



// WEBPACK FOOTER //
// ./src/store/index.js